import React from "react";
import useAuthorization from "../auth/useAuthorization";
import {useFirebaseIdentitaet} from "../auth/FirebaseIdentitaet";

import Badge from "react-bootstrap/Badge";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Search from "./Search";

const Menu = (props) => {
  const {abmelden} = useFirebaseIdentitaet();
  const {isAdmin: showAdmin} = useAuthorization();

  // Der Zähler kommt fertig von außen — aus derselben Datenquelle wie die
  // Mängelliste. Solange nichts Neues eingegangen ist, steht am Menüpunkt gar
  // nichts: eine „0" wäre ein Hinweis auf nichts.
  const neueMaengel = props.neueMaengel;

  return (
    <div className="headerMenu">
      <Navbar expand="lg" className="bg-body-tertiary">
        <Container>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="#" onClick={() => props.changePage("overview")}>
                Übersicht
              </Nav.Link>
              <Nav.Link href="#" onClick={() => props.changePage("maengel")}>
                Mängel
                {neueMaengel > 0 ? (
                  <Badge
                    bg="danger"
                    pill
                    className="ms-1"
                    aria-label={neueMaengel + " neu eingegangene Mängel"}
                  >
                    {neueMaengel}
                  </Badge>
                ) : undefined}
              </Nav.Link>
              <Nav.Link href="#" onClick={() => props.changePage("protokoll")}>
                Protokoll
              </Nav.Link>
              {showAdmin ? (
                <Nav.Link
                  href="#"
                  onClick={() => props.changePage("einstellungen")}
                >
                  Einstellungen
                </Nav.Link>
              ) : undefined}
              <Nav.Link href="#" onClick={() => props.changePage("changelog")}>
                Changelog
              </Nav.Link>
              <Nav.Link
                href="#"
                onClick={() => {
                  abmelden();
                }}
              >
                Abmelden
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
          {props.page === "overview" ||
          props.page === "maengel" ||
          props.page === "protokoll" ||
          props.page === "protokollFahrzeug" ? (
            <div className="search">
              <Search
                searchString={props.searchString}
                setSearchString={props.setSearchString}
              />
            </div>
          ) : undefined}
        </Container>
      </Navbar>
    </div>
  );
};

export default Menu;
